import type { UseCaseSection } from '../../../lib/useCaseQueries';
import { UcBenefitStatsSection } from './UcBenefitStatsSection';
import { UcComparisonTableSection } from './UcComparisonTableSection';
import { UcCtaBannerSection } from './UcCtaBannerSection';
import { UcFaqSection } from './UcFaqSection';
import { UcFeaturesSection } from './UcFeaturesSection';
import { UcFormatGridSection } from './UcFormatGridSection';
import { UcHeroSection } from './UcHeroSection';
import { UcPricingCalloutSection } from './UcPricingCalloutSection';
import { UcProblemStatsSection } from './UcProblemStatsSection';
import { UcTestimonialSection } from './UcTestimonialSection';
import { UcWorkflowStepSection } from './UcWorkflowStepSection';

type SectionRendererProps = {
  section: UseCaseSection;
  tone: 'light' | 'dark';
};

export function SectionRenderer({ section, tone }: SectionRendererProps) {
  switch (section._type) {
    case 'ucHero':
      return <UcHeroSection data={section} />;
    case 'ucProblemStats':
      return <UcProblemStatsSection data={section} tone={tone} />;
    case 'ucBenefitStats':
      return <UcBenefitStatsSection data={section} tone={tone} />;
    case 'ucWorkflowStep':
      return <UcWorkflowStepSection data={section} tone={tone} />;
    case 'ucFormatGrid':
      return <UcFormatGridSection data={section} tone={tone} />;
    case 'ucFeatures':
      return <UcFeaturesSection data={section} tone={tone} />;
    case 'ucComparisonTable':
      return <UcComparisonTableSection data={section} tone={tone} />;
    case 'ucTestimonial':
      return <UcTestimonialSection data={section} tone={tone} />;
    case 'ucPricingCallout':
      return <UcPricingCalloutSection data={section} tone={tone} />;
    case 'ucFaq':
      return <UcFaqSection data={section} tone={tone} />;
    case 'ucCtaBanner':
      return <UcCtaBannerSection data={section} />;
    default:
      return null;
  }
}
